function En() {
	var langs = {
		season: "Season",
		selectGameType: "Choose Game Type...",
		gameType: "GameTp",
		playerType: "SearchBy",
		team: "Team",
		hitter: "Hitter",
		oppTeam: "Opp.",
		pitcher: "Pitcher",
		recent6G: "Recent6G",
		pickOffs: "Pickoffs",
		pitcherTypes: "PitcherType",
		batterTypes: "BatterType",
		detailSearch: "Details",
		detailedFilter: "Detailed Filter",
		inning: "Inning",
		shortInning: "Inn.",
		top: "T",
		bottom: "B",
		pitchType: "Pitch Type",
		runner: "Runner Sit.",
		count: "Count",
		hitType: "Hit Type",
		playResult: "Play Result",
		search: "Search",
		regularSeason: "Regular Season",
		futuresSeason: "Futures Regular Season",
		reserveSquad: "Reserve Squad",
		postSeason: "Postseason",
		majorScrimmage: "Major-Scrimmage",
		futuresScrimmage: "Futures-Scrimmage",
		ExhibitionLeague: "Exhibition League",
		fallEduLeague: "Fall Educational League",
		inning1: "1st Inning",
		inning2: "2nd Inning",
		inning3: "3rd Inning",
		inning4: "4th Inning",
		inning5: "5th Inning",
		inning6: "6th Inning",
		inning7: "7th Inning",
		inning8: "8th Inning",
		inning9: "9th Inning",
		inning10: "10th Inning",
		inning11: "11th Inning",
		inning12: "12th Inning",
		inning13: "13th Inning",
		inning14: "14th Inning",
		inning15: "15th Inning",
		fastball: "Fastball",
		twoSeamer: "Two-Seamer(Sinker)",
		cutter: "Cutter",
		slider: "Slider",
		curve: "Curveball",
		changeUp: "ChangeUp",
		fork: "Forkball(Splitter)",
		other: "Other",
		single: "Single",
		double: "Double",
		triple: "Triple",
		homeRun: "HomeRun",
		itpHomeRun: "ITP HomeRun",
		groundBall: "Groundball",
		flyBall: "Flyball",
		reachedOnErr: "Reached on Error",
		fielderChoice: "Fielder's Choice",
		doublePlay: "Double Play",
		triplePlay: "Tirple Play",
		groundOut: "GroundOut",
		flyOut: "Flyout",
		lineOut: "Lineout",
		infieldFly: "Infield Fly",
		foul: "Foul",
		lineDrive: "LineDrive",
		foulFlyOut: "Foul Flyout",
		sacFly: "Sac Fly",
		sacBunt: "Sac Bunt",
		hittingObstruction: "Hitting Obstruction",
		fieldingInter: "Fielding/Catching Iterference",
		runningObstruction: "Running Obstruction",
		strikeOut: "Strikeout",
		baseOnBalls: "Base on Balls",
		hitByPitch: "Hit by Pitch",
		notOutSafe: "K Notout (Safe)",
		balk: "Pitcher Balk",
		wildPitch: "Wild Pitch",
		intentionalBB: "Intentional BB",
		passedBalls: "Passed Balls",
		buntFailedOut: "Bunt Failed Out",
		noRunner: "No Runner",
		runner1st: "Runner on 1st",
		runner2nd: "Runner on 2nd",
		runner3rd: "Runner on 3rd",
		runner1st2nd: "Runner on 1st,2nd",
		runner1st3rd: "Runner on 1st,3rd",
		runner2nd3rd: "Runner on 2nd,3rd",
		baseLoaded: "Base Loaded",
		standing: "Standing",
		hitting: "Hitting",
		strikeSwinging: "Strkie Swinging",
		buntPlay: "Bunt Play",
		pick1st: "Pick 1st Base",
		pick2nd: "Pick 2nd Base",
		pick3rd: "Pick 3rd Base",
		pickHome: "Pick Home Plate",
		catcherPick1st: "Catcher Picks 1st Base",
		catcherPick2nd: "Catcher Picks 2nd Base",
		catcherPick3rd: "Catcher Picks 3rd Base",
		selectTeamNPlayer: "Choose Player...",
		player: "Player",
		sortBy: "Sort By",
		selectAll: "Select All",
		desc: "DESC",
		asc: "ASC",
		watchClip: "WATCH Clip",
		gameSeq: "Seq.",
		gameDate: "Date",
		away: "AWAY",
		score: "SCORE",
		home: "HOME",
		clipType: "ClipType",

		pitch: "Pitch",
		pitchSpeed: "Speed",
		result: "Result",
		watchType: "Watch Type:",

		retrieveGames: "Please, retrieve the games",
		notExistGame: "There are no games that match on filters!",

		forStaff: "For Staff",
		caption: "Caption",
		repeat: "Rep",
		sequence: "Seq",
		justplay: "Full",
		
		battedBallRanks: "Rank",
		rankNone: "None",
		rankA: "A",
		rankB: "B",
		rankC: "C",

		leftPitcher: "vsLeftPitcher",
		rightPitcher: "vsRightPitcher",
		sidePitcher: "vsSidePitcher",

		leftBatter: "vsLeftBatter",
		rightBatter: "vsRightBatter",

		battedBallType: "BattedBall",

		minBallSpeed: "Min BallSpd",
		maxBallSpeed: "Max BallSpd",
		"~100": "~100",
		"100": "100",
		"105": "105",
		"110": "110",
		"115": "115",
		"120": "120",
		"125": "125",
		"130": "130",
		"135": "135",
		"140": "140",
		"145": "145",
		"150": "150",
		"155": "155",
		"160": "160",
		"165": "165",
		"165~": "165~"
	};

	return langs;
}

export default En;
